import { service } from '@ember/service';

import BaseAbility from 'umg-ember-backend/abilities/base';

export default class UserAbility extends BaseAbility {
  // Services
  @service permission;

  // Getter and setter
  get canUpdate() {
    return this.actions?.update ?? this.permission.user === this.model;
  }
}
